'use client';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

import Header from '@/components/elements/Header';
import { useSidebar } from '@/components/elements/Sidebar/sidebar-provider';

function Main({ children }: { children: ReactNode }) {
  const { isCollapsed, setIsCollapsed } = useSidebar();

  return (
    <main
      id="main-content"
      className={clsx(
        'flex h-screen flex-col justify-start overflow-hidden bg-[#F6F6F6]',
        isCollapsed ? 'pl-0 md:pl-20' : 'pl-0 md:pl-[260px]',
      )}
    >
      <Header />
      <div className="max-h-[calc(100svh-64px)] min-h-[calc(100svh-64px)] overflow-y-auto md:max-h-screen md:min-h-screen">
        {children}
      </div>
      {!isCollapsed && (
        <motion.div
          key="overlay"
          className="fixed inset-0 z-40 block bg-black/40 backdrop-blur-sm md:hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsCollapsed(!isCollapsed)}
        />
      )}
    </main>
  );
}
export default Main;
